<template>
  <div class="trend-chart">
    <v-chart :options="options" />
    <slot></slot>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

export default {
  data() {
    return {
      KEY_NAME_OBJ: {
        assuranceAmount: '担保额度',
        insuranceAmount: '保险额度',
        limitAmount: '总信用限额',
        validAmount: '当前有效额度',
      },
    }
  },
  props: ['dataSource'],
  computed: {
    options() {
      const dataSource = this.dataSource
      const xAxisData = []
      const seriesObj = {
        assuranceAmount: [],
        insuranceAmount: [],
        limitAmount: [],
        validAmount: [],
      }
      dataSource &&
        dataSource.forEach(element => {
          xAxisData.push(element.time)
          Object.keys(element).forEach(key => {
            if (seriesObj[key]) {
              seriesObj[key].push(element[key])
            }
          })
        })
      const options = {
        color: ['#F4667B', '#F7D15C', '#4DB8EF', '#57b13a'],
        title: {
          left: 'center',
        },
        xAxis: {
          type: 'category',
          data: xAxisData,
        },
        legend: {
          top: 50,
          data: ['担保额度', '保险额度', '总信用限额', '当前有效额度'],
          itemGap: 20,
        },
        yAxis: {
          type: 'value',
          name: '金额(万元)',
        },
        series: Object.keys(seriesObj).map(key => {
          return {
            name: this.KEY_NAME_OBJ[key],
            data: seriesObj[key],
            type: 'line',
          }
        }),
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'line', // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          top: 120,
          containLabel: true,
        },
      }
      return options
    },
  },
  components: {
    'v-chart': ECharts,
  },
}
</script>

<style lang="less" scoped>
.trend-chart {
  .echarts {
    display: inline-block;
    vertical-align: middle;
    width: 800px;
    height: 500px;
  }
}
</style>
